(function() {

    'use strict';

    angular.module('Services').factory('FleetDriverGroupsTableService', FleetDriverGroupsTableService);

    function FleetDriverGroupsTableService($location, FleetService, TableLiteFactory, toastr) {
        return function () {
            const tableData = {
                tableName: 'DriverGroupsTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New',
                        tooltip: 'Add New Driver Group',
                        onClick: function(){
                            $location.path('/fleets/driver-groups/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Group ID',
                    viewName: 'groupId',
                    filterName: 'groupId',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Group Name',
                    viewName: 'name',
                    filterName: 'name',
                    sortName: 'description',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.sortName);
                    }
                }, {
                    label: 'Description',
                    viewName: 'description',
                    filterName: 'description',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: 'companyName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                /*}, {
                    label: 'Route',
                    viewName: 'route',
                    filterName: 'route',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }*/
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function(header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.DriverGroups.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(group, index) {
                    group.status = {
                        type: 'status',
                        status: group.active,
                        label: group.active ? 'Active' : 'Inactive'
                    };
                    group.companyName = group.companyName;
                    group.href = '/fleets/driver-groups/details/' + group.id;

                    tableData.data.push(group);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/FleetDriverGroupsTableService.js